/**
 * Utility functions for handling timezone operations
 */

/**
 * Gets the user's browser timezone
 * @returns The IANA timezone string (e.g., "America/New_York")
 */
export const getBrowserTimezone = (): string => {
  try {
    // Use the Intl.DateTimeFormat API to get the timezone
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timezone;
  } catch (error) {
    console.error("Error getting browser timezone:", error);
    // Fallback to UTC if unable to determine timezone
    return "America/Los_Angeles";
  }
};
